import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import * as _ from "./lodash";
import mapProps from "./map-props";
export default function toUIProps(_ref) {
  var _context;

  var props = _ref.props,
      _ref$propMap = _ref.propMap,
      propMap = _ref$propMap === void 0 ? {} : _ref$propMap,
      _ref$UNSUPPORTED_PROP = _ref.UNSUPPORTED_PROPS,
      UNSUPPORTED_PROPS = _ref$UNSUPPORTED_PROP === void 0 ? [] : _ref$UNSUPPORTED_PROP,
      _ref$ADDED_PROPS = _ref.ADDED_PROPS,
      ADDED_PROPS = _ref$ADDED_PROPS === void 0 ? [] : _ref$ADDED_PROPS,
      _ref$MODIFIED_PROPS = _ref.MODIFIED_PROPS,
      MODIFIED_PROPS = _ref$MODIFIED_PROPS === void 0 ? [] : _ref$MODIFIED_PROPS;

  /*
    TEMPORARILY DISABLING BECAUSE WAS FIRING TOO AGGRESSIVELY
    TEST WITH MULTISELECT STORY
  */
  // if (process.env.__DEV__) {
  //   const passedUnsupportedProps = _.pick(props, UNSUPPORTED_PROPS);
  //   logger.warn(
  //     `You are trying to pass unsupported props. They will not be applied: ${_.keys(passedUnsupportedProps)}`,
  //     !_.isEmpty(passedUnsupportedProps)
  //   );
  // }
  var UIProps = _.omit(props, UNSUPPORTED_PROPS);

  UIProps = mapProps(propMap, UIProps);
  UIProps = _.omit(UIProps, _concatInstanceProperty(_context = []).call(_context, MODIFIED_PROPS, ADDED_PROPS));
  return UIProps;
}
//# sourceMappingURL=to-ui-props.js.map